import React, { useState, useEffect } from 'react'
import useQuery from '@/hooks/useQuery'
import { CheckCircleIcon } from '@heroicons/react/solid'

import classNames from '@/utils/classNamesLocal'
import { SVGIcon } from '@/components/icon'
import Loading from '@/shared/Loading'

// key matches jbuilder file
const userMetaList = {
  'voiceActor': { image: 'voiceactor', text: 'Voice Actor', to_db: 'voice_actor' },
  'liveActor': { image: 'actor', text: 'Actor', to_db: 'live_actor' },
  'singer': { image: 'singer', text: 'Singer', to_db: 'singer' },
  'artist': { image: 'artist', text: 'Artist', to_db: 'artist' },
  'animator': { image: 'animator', text: 'Animator', to_db: 'animator' },
  'videoEditor': { image: 'video-editor', text: 'Video Editor', to_db: 'video_editor' },
  'musicComposer': { image: 'musiccomposer', text: 'Music Composer', to_db: 'music_composer' },
  'audioEngineer': { image: 'audio-engineer', text: 'Audio Engineer', to_db: 'audio_engineer' },
  'writer': { image: 'writer', text: 'Writer', to_db: 'writer' },
  'director': { image: 'director', text: 'Director', to_db: 'director' },
  'agent': { image: 'agent', text: 'Agent', to_db: 'agent' },
  'producer': { image: 'producer', text: 'Producer', to_db: 'producer' }
}

const OnboardingUserMeta = () => {
  const { getRequest, putpostRequest } = useQuery()
  const [userMeta, setUserMeta] = useState({})
  const [initialLoading, setInitialLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => { fetchData() }, [])

  const fetchData = () => {
    setInitialLoading(true)
    getRequest('/api/v3/user_metas', {}, (err, jsonData) => {
      setInitialLoading(false)
      if (err) { /* hook */ return }
      setUserMeta(jsonData.userMeta)
    })
  }

  const toggleUserMeta = (key) => {
    const val = userMeta[key]

    setLoading(key)
    const data = {
      [userMetaList[key].to_db]: !val
    }
    putpostRequest('/api/v3/user_metas/update_meta', 'POST', { user_meta: data }, (err, jsonData) => {
      setLoading(false)
      if (err) { /* hook */ return }

      setUserMeta({ ...userMeta, [key]: !val })
    })
  }

  if (initialLoading) { return <Loading /> }

  return (
    <div className='text-gray-800 dark:text-gray-200 max-w-4xl mx-auto'>
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 dark:text-gray-100">I am a...</h3>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Select all that apply to you</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        { Object.keys(userMetaList).map((key) => (
          <div key={`role${key}`} className="relative">
            { loading === key ? (
              <div className="flex items-center justify-center h-24 bg-gray-100 dark:bg-gray-700 rounded-xl">
                <Loading noMessage noLoadingMessage />
              </div>
            ) : (
              <button
                onClick={() => toggleUserMeta(key)}
                className={classNames(
                  userMeta[key]
                    ? 'bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/30 border-green-500 shadow-green-100 dark:shadow-none'
                    : 'bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 hover:shadow-md',
                  'relative w-full flex flex-col items-center justify-center p-4 h-24 border-2 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cccpurple shadow-sm'
                )}
              >
                { userMeta[key] && (
                  <CheckCircleIcon className="absolute -top-2 -right-2 h-6 w-6 text-green-500 bg-white dark:bg-gray-800 rounded-full shadow-sm" />
                )}
                <SVGIcon name={userMetaList[key].image} width='36' height='36' autoDark />
                <span className={classNames(
                  userMeta[key] ? 'text-green-700 dark:text-green-300 font-semibold' : 'text-gray-700 dark:text-gray-300',
                  'mt-2 text-xs'
                )}>
                  {userMetaList[key].text}
                </span>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default OnboardingUserMeta

OnboardingUserMeta.propTypes = { }
